const PERFORMED_BY = [
  { value: 0, text: 'HealthcareProfessional' },
  { value: 1, text: 'Patient' },
  { value: 2, text: 'Other' }
];

type PERFORMED_BY = typeof PERFORMED_BY;

export default PERFORMED_BY;
